import { css, useTheme } from "@emotion/react";

import parseStyle from "./parseStyle.js";
import Typography from "./Typography.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function Excerpt(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "Excerpt" });
  let {
    lines = 4,
    children,
    style,
    as: Component = Typography,
    ...restProps
  } = props;
  return (
    <Component
      css={css`
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: ${lines};
        -webkit-box-orient: vertical;
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {children}
    </Component>
  );
}
